import { createSelector } from 'reselect';

import { selectLoanApplication } from './loanApplication.selectors';

export const selectLoanKeyDates = createSelector(
  selectLoanApplication,
  ({ loanKeyDates }) => loanKeyDates,
);
